import { ObservableFromFetch } from "../ObservableFromFetch"

export function SelectionReportPrint(selectionInterval: string) {
  const requestBody: string = new URLSearchParams({
    selectionInterval: selectionInterval
  }).toString()

  return ObservableFromFetch<string>("GovPool/GroupSelectionPdfReport?" + requestBody)
}
